export default __webpack_public_path__ + "3c64defcbaa45bc5a6c9750a8219767a.svg";